
































import { Component, Vue } from "vue-property-decorator";
import { translate } from "@/utils";
import { TransformatorsModule } from "@/store/transformators.module";
import { Transformator } from "~/transformator.type";
import { DataTableOption } from "~/DataTableOption.type";
import ExpansionPanel from "../ui/ExpansionPanel.vue";

@Component({
  components: { ExpansionPanel },
})
export default class PointTransView extends Vue {
  get headers() {
    return [
      {
        text: this.$t("pointTrans.transformer_number"),
        value: "transformer_number",
        sortable: false,
      },
      {
        text: this.$t("pointTrans.transformer_name"),
        value: "transformer_name",
        sortable: false,
      },
      {
        text: this.$t("pointTrans.koef"),
        value: "koef",
        sortable: false,
      },
      {
        text: this.$t("pointTrans.meter_seal_number"),
        value: "meter_seal_number",
        sortable: false,
      },
    ];
  }

  get transListPagination(): DataTableOption {
    return TransformatorsModule.transListPagination;
  }
  set transListPagination(val) {
    TransformatorsModule.setTransListPagination(val);
    this.loadTrans();
  }

  get loading(): boolean {
    return TransformatorsModule.transListLoading;
  }

  get getTransList(): Transformator[] {
    return translate(TransformatorsModule.transList);
  }

  get transListLength(): number {
    return TransformatorsModule.transListLength;
  }

  async mounted() {
    TransformatorsModule.setNewTransList();
    this.loadTrans();
  }

  loadTrans(): void {
    TransformatorsModule.getTransList({
      iAccountPointRid: parseInt(this.$route.params.pointId),
      iLimit: this.transListPagination.itemsPerPage,
      iOffset:
        this.transListPagination.itemsPerPage *
        (this.transListPagination.page - 1),
    });
  }
}
